import gql from "graphql-tag";

export const UpdateEmailPreferences = gql`
  mutation UpdateEmailPreferences($preferences: String!, $token: String) {
    updateAccountInfo(account: { emailPreferences: $preferences, emailPreferenceToken: $token })
  }
`;
